import { Stack, Text } from "@chakra-ui/react";
import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title: "How does Dedicated Internet Access (DIA) differ from standard broadband?",
    content:
      "DIA provides symmetrical upload and download speeds, guaranteed bandwidth, and a 99.99% uptime SLA, making it far more reliable and consistent than standard broadband.",
  },
  {
    title: "Why is carrier-neutral DCI important for businesses?",
    content:
      "Carrier-neutral DCI allows businesses to connect multiple data centers across different providers, enabling greater flexibility, redundancy, and cost-efficiency while avoiding vendor lock-in.",
  },
  {
    title: "How does DCI improve disaster recovery?",
    content:
      "DCI provides low-latency, high-speed data replication, ensuring real-time backup synchronization and fast recovery times in case of outages or failures.",
  },
  {
    title: "What security measures are in place for DCI connections?",
    content:
      "Our DCI services leverage private fiber interconnects, encryption, and advanced network monitoring to ensure secure data transfer between locations.",
  },
  {
    title: "Can bandwidth be adjusted as business needs evolve?",
    content:
      "Yes! Our scalable bandwidth options allow businesses to increase or decrease capacity based on real-time demand.",
  },
  {
    title: "How does DCI support multi-cloud strategies?",
    content:
      "DCI enables direct, high-speed connectivity to multiple cloud providers, optimizing hybrid and multi-cloud deployments for improved performance and reliability.",
  },
  {
    title: "What industries benefit the most from DIA and DCI solutions?",
    content:
      "Industries such as finance, healthcare, e-commerce, manufacturing, and government benefit from secure, high-speed, and redundant connectivity for critical operations and compliance needs.",
  },
  {
    title:
      "What is the difference between Layer 2 and Layer 3 Data Center Interconnect (DCI)?",
    content: (
      <SimpleList
        points={[
          "Layer 2 DCI extends a single network across multiple data centers, enabling seamless workload mobility and virtual machine migration.",
          "Layer 3 DCI provides routing between different networks, ensuring higher scalability, better security, and efficient traffic control across data centers.",
        ]}
      />
    ),
  },
  {
    title: "How do the Internet and DCI improve cloud connectivity?",
    content: (
      <SimpleList
        points={[
          "Dedicated Internet Access (DIA) provides direct peering with major cloud providers, reducing latency and improving cloud application performance.",
          "DCI solutions offer high-speed, private connections to cloud environments, enabling secure multi-cloud and hybrid cloud architectures.",
        ]}
      />
    ),
  },
  {
    title: "What are the latency and speed benefits of carrier-neutral DCI?",
    content: (
      <SimpleList
        points={[
          "Ultra-low latency (as low as sub-millisecond) between interconnected data centers.",
          "Speeds up to 100 Gbps, ensuring fast data replication, backup, and real-time workload distribution.",
          "Diverse fiber routes reduce network congestion and improve failover reliability.",
        ]}
      />
    ),
  },
  {
    title: "Can DCI support real-time applications like VoIP and video conferencing?",
    content: (
      <Stack>
        <Text>
          Yes! DCI solutions provide high-speed, low-latency connections that optimize
          performance for:{" "}
        </Text>
        <SimpleList
          points={[
            "VoIP and video conferencing by reducing jitter and packet loss.",
            "Real-time financial transactions in trading and banking industries.",
            "High-frequency data exchange in AI, IoT, and big data environments.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "How does DCI help businesses with compliance and data sovereignty?",
    content: (
      <SimpleList
        points={[
          "Enables businesses to store and process data in specific regions to comply with regulations such as PCI-DSS.",
          "Private interconnects prevent data exposure to public networks, ensuring secure, regulatory-compliant data transfers.",
        ]}
      />
    ),
  },
  {
    title:
      "What redundancy and failover options are available for Internet and DCI services?",
    content: (
      <SimpleList
        points={[
          "Multi-path fiber redundancy ensures traffic is rerouted instantly in case of a failure.",
          "Automatic failover mechanisms provide continuous connectivity with minimal disruption.",
          "Dual or multiple carrier options enhance reliability and reduce the risk of provider-specific outages.",
        ]}
      />
    ),
  },
  {
    title: "How does OneMind Services ensure security in Internet and DCI solutions?",
    content: (
      <Stack>
        <Text>OneMind Services implements multiple layers of security, including: </Text>
        <SimpleList
          points={[
            "Encrypted transport links to protect data in transit.",
            "AI-driven network monitoring to detect and prevent threats in real time.",
            "DDoS mitigation solutions to protect against cyber attacks.",
            "Segmented network traffic to isolate workloads and enhance security.",
          ]}
        />
      </Stack>
    ),
  },
];
